import Link from '@/components/utilities/SmartLink';
import ChevronRight from '@/components/ui/icons/ChevronRight';

const MenuItemBlockDirectLink = ({ label, link }) => {
  return (
    <div className="flex justify-end">
      <Link
        href={link}
        target={link.startsWith('http') ? '_blank' : '_self'}
        rel={link.startsWith('http') ? 'noopener noreferrer' : undefined}
        className="txt-md hover:text-brand-400 text-grey-700 flex items-center font-medium tracking-wider"
      >
        <span className="underline">{label}</span>
        <ChevronRight width={24} height={24} />
      </Link>
    </div>
  );
};
export default MenuItemBlockDirectLink;
